import { render, staticRenderFns } from "./CategoryIcon.vue?vue&type=template&id=5455bf8c"
import script from "./CategoryIcon.vue?vue&type=script&lang=js"
export * from "./CategoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports